import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useCancelFileUploadRequestMutation as useCancelFileUploadRequestMutationType } from "@/modules/patients/services/__generated__/useCancelFileUploadRequestMutation.graphql"

const mutation = graphql`
  mutation useCancelFileUploadRequestMutation($input: CancelFileUploadRequestInput!) {
    cancelFileUploadRequest(input: $input) {
      fileUploadRequest {
        ...FileUploadRequestFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useCancelFileUploadRequestMutation = (params?: CustomMutationParams) => {
  const [commit, isInFlight] = useMutationWithErrorDialog<useCancelFileUploadRequestMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCancelFileUploadRequestMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isInFlight] as const
}

export { useCancelFileUploadRequestMutation }
